import React from 'react';
import VenuesForm from './VenuesForm';

const EditVenuePage = () => {
    return <VenuesForm formType="edit" />;
};

export default EditVenuePage;

